import React from 'react';
import cx from 'classnames';
import { Layout } from 'antd';

import './shared-footer.css';

const SharedFooter = ({ className, showPartners = true }) => {
  const { Footer } = Layout;

  const partners = [
    {
      image: require('./../../assets/sponsor1.png'),
      url: 'https://www.ikuluzanzibar.go.tz/',
      alt: 'Government of Zanzibar',
    },
    {
      image: require('./../../assets/sponsor2.png'),
      url: 'https://zanzibartourism.go.tz/',
      alt: 'Zanzibar Commission for Tourism',
    },
    {
      image: require('./../../assets/sdgailab_logo.png'),
      url: 'https://sdgailab.org',
      alt: 'SDG AI Lab',
    },
    {
      image: require('./../../assets/sponsor3.png'),
      url: 'https://www.undp.org/tanzania',
      alt: 'UNDP Tanzania',
    },
  ];

  return (
    <Footer className={cx('footer footer-container', className)}>
      <div className="footer-shell">
        {showPartners && (
          <section className="footer-partners">
            <div className="footer-partners-heading">
              <span className="footer-eyebrow">Built With</span>
              <h2>Partners Supporting AI for Tourism</h2>
            </div>
            <div className="partners-logos">
              {partners.map((partner, index) => (
                <a
                  key={index}
                  href={partner.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="partner-link"
                  title={partner.alt}
                >
                  <img className="home-sponsors-image" src={partner.image} alt={partner.alt} />
                </a>
              ))}
            </div>
          </section>
        )}

        <div className="footer-logo-container">
          <div className="footer-brand-block">
            <div className="footer-logo">
              <img src={require('./../../assets/footer-logo.png')} alt="JozaniAI logo" />
              <span className="footer-copyright">© 2025</span>
            </div>
            <p className="footer-tagline">
              Tourism intelligence for Zanzibar, refined for outreach and decision support.
            </p>
          </div>

          <div className="footer-links-block">
            <span className="quick-links">Quick Links</span>
            <div className="footer-links">
              <a href="/about">About</a>
              <span className="footer-link-divider">/</span>
              <a href="/faqs">FAQs</a>
              <span className="footer-link-divider">/</span>
              <a href="/privacy">Privacy Policy</a>
            </div>
          </div>
        </div>
      </div>
    </Footer>
  );
};

export default SharedFooter;
